import { render, staticRenderFns } from "./RecordButton.vue?vue&type=template&id=5a4b3674&scoped=true"
import script from "./RecordButton.vue?vue&type=script&lang=tsx"
export * from "./RecordButton.vue?vue&type=script&lang=tsx"
import style0 from "./RecordButton.vue?vue&type=style&index=0&id=5a4b3674&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4b3674",
  null
  
)

export default component.exports